import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../api';

const ChatList = ({ onSelectChat }) => {
  if (!onSelectChat) {
    console.error('onSelectChat function is missing in ChatList props!');
  }

  const [chatList, setChatList] = useState([]);
  const [message, setMessage] = useState('');
  const getAuthToken = () => localStorage.getItem('stack_access_token');

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/messages/chats`, {
      method: 'GET',
      headers: {
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch chat list');
        }
        return response.json();
      })
      .then((data) => setChatList(data))
      .catch((error) => {
        console.error('Error fetching chat list:', error);
        setMessage('Failed to load chat list.');
      });
  }, []);

  const handleChatClick = async (chatPartnerId) => {
    const token = getAuthToken();
    console.log('Clicked chat ID:', chatPartnerId);

    // Update UI immediately by setting unread_count to 0 for the clicked chat
    setChatList((prevChats) =>
      prevChats.map((chat) =>
        chat.chat_partner_id === chatPartnerId
          ? { ...chat, unread_count: 0 } // Clear unread messages in UI
          : chat,
      ),
    );

    onSelectChat(chatPartnerId); // Open the chat

    // Send a request to backend to mark messages as read
    try {
      await fetch(`${API_BASE_URL}/api/messages/mark-read/${chatPartnerId}`, {
        method: 'POST',
        headers: {
          'X-Stack-Access-Token': token,
        },
      });
      console.log(`Messages marked as read for chat ID: ${chatPartnerId}`);
    } catch (error) {
      console.error('Failed to mark messages as read:', error);
    }
  };

  return (
    <div className="w-full h-full p-4 bg-gray-900 text-white overflow-y-auto">
      <h1 className="text-2xl font-bold mb-4">Chats</h1>
      {message && <p className="text-sm text-red-400">{message}</p>}

      <ul className="space-y-4">
        {chatList.map((chat) => (
          <li
            key={chat.chat_partner_id}
            className="flex items-center gap-4 p-3 rounded-lg cursor-pointer hover:bg-gray-800 transition duration-200"
            onClick={() => handleChatClick(chat.chat_partner_id)}
          >
            {/* Profile Picture */}
            <img
              src={
                chat.chat_partner_picture || 'https://via.placeholder.com/50'
              }
              alt={chat.chat_partner_name}
              className="w-14 h-14 rounded-full object-cover"
            />

            {/* Chat Info */}
            <div className="flex-1 min-w-0">
              <p className="text-lg font-semibold truncate">
                {chat.chat_partner_name}
              </p>
              <p className="text-sm text-gray-400 truncate w-full">
                {chat.last_message_text}
              </p>
            </div>

            {/* Unread Messages Badge */}
            {chat.unread_count > 0 && (
              <span className="bg-primary text-xs text-white px-3 py-1 rounded-full">
                {chat.unread_count}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChatList;
